const addResetAndHideBtn = () => {
  if (!document.querySelector(".personalize-it--js")) return;
  const builder = document.getElementById("#product-builder");
  const basicProduct = document.querySelector(".shopify-section.section-product");
  const resetBtn = document.querySelector(".cpb-actions-btn.cpb-reset-button");
  const hideBtn = document.createElement("button");
  hideBtn.classList.add("cpb-hide-button");
  builder.querySelector(".cpb-layout").appendChild(hideBtn);
  const hidingStyles =
    builder.getAttribute("style") ||
    "height:0px !important;min-height:0px;opacity:0;pointer-events:none;";

  const clickHandle = () => {
    resetBtn.click();
    document
      .querySelector(".swal2-container button.swal2-confirm")
      .addEventListener("click", confirmed);
  };

  const confirmed = () => {
    builder.style.display = 'none'
    basicProduct.style.display = 'block'
  };

  hideBtn.addEventListener("click", clickHandle);
};

document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", addResetAndHideBtn);


const scrollToTop = () => {
  const personalizeBtn = document.querySelector(".personalize-it--js");
  personalizeBtn.addEventListener('click', () => {scrollTo(0, 0)})
}

const showCPB = () => {
  const baseProduct = document.querySelector('.shopify-section.section-product')
  const cpbProduct = document.querySelector('#product-builder')
  baseProduct.style.display = 'block'
  cpbProduct.style.display = 'none'
  const personalizeBtn = document.querySelector(".personalize-it--js")
  personalizeBtn.addEventListener('click', () => {
    baseProduct.style.display = 'none'
    cpbProduct.style.display = 'block'
  })
}

addEventListener("DOMContentLoaded", () => {
  scrollToTop()
  showCPB()
});